import React from "react";
import './scrollindicator.css'
const ScrollIndicator = () => {

    return <div className="scroll-indicator">
        <div className="arrow-down"></div>
    </div>
};

export default ScrollIndicator;
